/**
 * Button component
 * ----------------
 */

/* Imports */

import React from "react";
import { Button, ButtonOutline } from "./styles.module.scss";

/* Component */

const ButtonComponent = ({
  outline = false,
  theme = "orange",
  text = "",
  link = "",
  classes = "",
  innerClasses = "",
  target = "_self",
  canDisable = true,
}) => {
  let linkClass = `${outline ? ButtonOutline : Button} lc-h3-xs lc-button`;
  let spanClass = "lc-p-r lc-z-1";

  if (outline) linkClass += `-outline lc-${theme}`;

  if (classes) linkClass += ` ${classes}`;

  if (innerClasses) spanClass += ` ${innerClasses}`;

  return outline ? (
    <a
      className={linkClass}
      href={link}
      data-sc="m"
      target={target}
      data-can-disable={canDisable.toString()}
    >
      <div>
        <span className={spanClass}>{text}</span>
      </div>
    </a>
  ) : (
    <a
      className={linkClass}
      href={link}
      data-sc="m"
      target={target}
      data-can-disable={canDisable.toString()}
    >
      <div>
        <span className={spanClass}>{text}</span>
      </div>
    </a>
  );
};

/* Export */

export default ButtonComponent;
